// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #215f99;
  --primary-dark: #174a78;
  --primary-light: #317dbd;
  --primary-soft: #eaf4ff;

  --background: #f4f6f8;
  --surface: #ffffff;
  --surface-soft: #f8fafc;

  --text: #1f2933;
  --heading: #17324d;
  --muted: #5f6c7b;
  --border: #dfe3e8;

  --success: #18794e;
  --success-soft: #e7f6ee;
  --warning: #b54708;
  --warning-soft: #fdf1e4;
  --danger: #c0362c;
  --danger-soft: #fbe9e7;

  --shadow: 0 2px 10px rgba(23, 50, 78, 0.06);
  --shadow-lg: 0 10px 28px rgba(23, 50, 78, 0.12);
}

/* =========================
   Fancy Loading Spinner
========================= */

.a3-repo-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 20px;
}

.a3-repo-spinner {
  width: 60px;
  height: 60px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid var(--primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.a3-repo-loading-text {
  font-size: 16px;
  font-weight: 500;
  color: var(--muted);
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.a3-repo-loading-dots::after {
  content: '';
  animation: dots 1.5s steps(4, end) infinite;
}

@keyframes dots {
  0%, 20% { content: '.'; }
  40% { content: '..'; }
  60%, 100% { content: '...'; }
}

.a3-repo-error {
  color: var(--danger);
  margin-top: 20px;
  font-weight: 500;
}

/* =========================
   Repository Container
========================= */

.a3-repository-container {
  padding: 24px 28px;
  background: var(--background);
  min-height: 100vh;
  zoom: 0.8;
}

.a3-repository-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
}

.a3-repository-container h2 {
  margin: 0 0 6px;
  color: var(--heading);
  font-size: 24px;
  font-weight: 800;
}

.a3-repository-subtitle {
  margin: 0 0 24px;
  color: var(--muted);
  font-size: 14px;
  font-weight: 400;
}

.new-a3-btn {
  background: #0369a1;
  color: #fff;
  padding: 10px 18px;
  border-radius: 999px;
  border: none;
  font-weight: 700;
  box-shadow: 0 8px 22px rgba(3,105,161,0.18);
  cursor: pointer;
  font-size: 13px;
  transition: all 0.15s ease;
}

.new-a3-btn:hover {
  background: #025a8a;
  transform: translateY(-2px);
  box-shadow: 0 12px 30px rgba(3,105,161,0.26);
}

.new-a3-btn:active {
  background: #024f7a;
  transform: translateY(0);
}

/* =========================
   KPI Section
========================= */

.a3-kpi-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 24px;
}

.a3-kpi-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px;
  box-shadow: var(--shadow);
}

.a3-kpi-value {
  font-size: 24px;
  font-weight: 800;
  color: var(--primary);
}

.a3-kpi-label {
  margin-top: 4px;
  font-size: 11px;
  text-transform: uppercase;
  color: var(--muted);
  font-weight: 700;
}

/* =========================
   Repository Cards Grid
========================= */

.a3-content-layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.a3-left-column {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 280px;
  min-width: 260px;
  position: sticky;
  top: 16px;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  padding-bottom: 20px;
}

.a3-left-column::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.a3-repository-grid {
  flex: 1 1;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 16px;
}

/* =========================
   Repository Card
========================= */

.a3-summary-card {
  background: var(--surface);
  border: 1.5px solid var(--border);
  border-radius: 14px;
  padding: 18px;
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.15s ease;
}

.a3-summary-card:hover {
  border-color: var(--primary-light);
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}

.a3-card-title {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.4;
  color: var(--heading);
}

.a3-card-detail-item {
  margin-bottom: 8px;
  font-size: 12.5px;
  color: var(--muted);
}

.a3-card-detail-item strong {
  color: var(--heading);
}

.a3-card-detail-item:last-of-type {
  margin-bottom: 16px;
}

/* =========================
   Metadata Inline Row
========================= */

.a3-card-meta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 12.5px;
  color: var(--muted);
  font-weight: 500;
}

.a3-card-meta-row span {
  color: var(--heading);
  font-weight: 600;
}

.dot-separator {
  color: var(--muted) !important;
  font-weight: 400 !important;
  margin: 0 2px;
}

/* =========================
   Tag Highlighting Options
========================= */


/* Option 3: Teal/Cyan Modern */
.a3-card-tag {
  display: inline-block;
  background: #ecfeff;
  color: #0e7490;
  font-size: 13px;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 8px;
  border-left: 3px solid #06b6d4;
  box-shadow: 0 1px 2px rgba(6, 182, 212, 0.1);
}



/* =========================
   Status Badges
========================= */

.a3-card-status-badge {
  font-size: 10px;
  font-weight: 800;
  padding: 3px 10px;
  border-radius: 999px;
}

.a3-card-status-implemented {
  background: var(--success-soft);
  color: var(--success);
}

.a3-card-status-inprogress {
  background: var(--warning-soft);
  color: var(--warning);
}

.a3-card-status-notstarted {
  background: #f1f5f9;
  color: #475569;
}

.a3-card-status-default {
  background: #eef2f6;
  color: #475569;
}

/* =========================
   Savings
========================= */

.a3-card-savings-value {
  color: var(--success);
  font-weight: 800;
}

.a3-card-savings-not-recorded {
  color: #9ca3af;
  font-weight: 500;
  font-style: italic;
}

/* =========================
   Open Button
========================= */

.a3-card-open-btn {
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  margin-top: 12px;
  transition: all 0.2s ease;
}

.a3-card-open-btn:hover {
  background: var(--primary-dark);
}

/* =========================
   Card Action Buttons Row
========================= */

.a3-card-actions {
  display: flex;
  gap: 8px;
  margin-top: 14px;
  flex-wrap: wrap;
}

.a3-card-action-btn {
  flex: 1 1;
  min-width: 60px;
  border: none;
  border-radius: 7px;
  padding: 8px 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
}

.a3-card-btn-open {
  background: var(--primary);
  color: #fff;
}

.a3-card-btn-open:hover {
  background: var(--primary-dark);
}

.a3-card-btn-edit {
  background: #f3f4f6;
  color: #4b5563;
  border: 1.5px solid #d1d5db;
}

.a3-card-btn-edit:hover {
  background: #e5e7eb;
}

.a3-card-btn-export {
  background: #f3f4f6;
  color: #4b5563;
  border: 1.5px solid #d1d5db;
}

.a3-card-btn-export:hover {
  background: #e5e7eb;
}

.a3-card-btn-delete {
  background: #f3f4f6;
  color: #4b5563;
  border: 1.5px solid #d1d5db;
}

.a3-card-btn-delete:hover {
  background: #e5e7eb;
}

.a3-card-btn-confirm-delete {
  background: var(--danger);
  color: #fff;
  border: 1.5px solid var(--danger);
  animation: a3-pulse 0.25s ease;
}

.a3-card-btn-confirm-delete:hover {
  background: #a02820;
}

@keyframes a3-pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.06); }
  100% { transform: scale(1); }
}

/* =========================
   Loading & Empty States
========================= */

.a3-loading {
  text-align: center;
  padding: 40px 20px;
  color: #9aa7b8;
  font-size: 14px;
}

.a3-empty-state {
  grid-column: 1 / -1; /* Span all columns */
  text-align: center;
  padding: 60px 40px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 16px;
  border: 2px dashed #cbd5e1;
  margin: 40px auto;
  max-width: 500px;
}

.a3-empty-state-icon {
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.6;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

.a3-empty-state-title {
  font-size: 20px;
  font-weight: 700;
  color: #475569;
  margin-bottom: 12px;
}

.a3-empty-state-message {
  font-size: 15px;
  color: #64748b;
  line-height: 1.6;
  margin-bottom: 20px;
}

.a3-empty-state-suggestion {
  font-size: 13px;
  color: #94a3b8;
  font-style: italic;
}

.a3-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
}

.a3-card-title {
  margin: 0;
  flex: 1 1;
  font-size: 15px;
  font-weight: 800;
  color: var(--heading);
}

/* =========================
   Filters Panel
========================= */

.a3-filters-panel {
  width: 100%;
  background: var(--surface);
  border: 1.5px solid var(--border);
  border-radius: 14px;
  padding: 14px 14px;
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-sizing: border-box;
}

.a3-filters-panel::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.a3-filters-title {
  font-size: 13px;
  font-weight: 800;
  color: var(--heading);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 2px;
}

.a3-filter-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.a3-filter-label {
  font-size: 12.5px;
  font-weight: 700;
  color: var(--heading);
}

.a3-filter-input,
.a3-filter-select {
  width: 100%;
  padding: 8px 10px;
  border: 1.5px solid var(--border);
  border-radius: 8px;
  font-size: 12.5px;
  color: var(--text);
  background: var(--surface-soft);
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;
}

.a3-filter-input:focus,
.a3-filter-select:focus {
  border-color: var(--primary-light);
  background: #fff;
}

.a3-filter-reset-btn {
  margin-top: 4px;
  width: 100%;
  padding: 8px 12px;
  background: #e2e8f0;
  color: #475569;
  border: 1.5px solid #cbd5e1;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
}

.a3-filter-reset-btn:hover:not(:disabled) {
  background: #cbd5e1;
  color: #334155;
}

.a3-filter-reset-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* =========================
   Insights Box
========================= */

.a3-insights-box {
  background: #e0f2fe;
  border: 1.5px solid #bae6fd;
  border-radius: 14px;
  padding: 12px 14px;
  box-sizing: border-box;
}

.a3-insights-box::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.a3-insights-title {
  font-size: 12px;
  font-weight: 800;
  color: #0369a1;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 8px;
}

.a3-insights-list {
  margin: 0;
  padding-left: 18px;
  list-style: disc;
}

.a3-insights-list li {
  font-size: 12px;
  color: #0c4a6e;
  line-height: 1.5;
  font-weight: 500;
  margin-bottom: 6px;
}

.a3-insights-list li:last-child {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/ieHub/A3Repository.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;;EAEvB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;;EAEvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;;EAEjB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;;EAEtB,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,UAAU,YAAY,EAAE;EACxB,MAAM,aAAa,EAAE;EACrB,YAAY,cAAc,EAAE;AAC9B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,gBAAgB;EAC1C,oBAAoB;AACtB;;AAEA;EACE,aAAa,EAAE,0BAA0B;AAC3C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;;2BAE2B;;AAE3B;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,aAAa;AACf;;AAEA;;2BAE2B;;;AAG3B,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,4CAA4C;AAC9C;;;;AAIA;;2BAE2B;;AAE3B;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;2BAE2B;;AAE3B;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;2BAE2B;;AAE3B;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB,EAAE,qBAAqB;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;2BAE2B;;AAE3B;EACE,WAAW;EACX,0BAA0B;EAC1B,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa,EAAE,0BAA0B;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;EAEE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;2BAE2B;;AAE3B;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa,EAAE,0BAA0B;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[":root {\n  --primary: #215f99;\n  --primary-dark: #174a78;\n  --primary-light: #317dbd;\n  --primary-soft: #eaf4ff;\n\n  --background: #f4f6f8;\n  --surface: #ffffff;\n  --surface-soft: #f8fafc;\n\n  --text: #1f2933;\n  --heading: #17324d;\n  --muted: #5f6c7b;\n  --border: #dfe3e8;\n\n  --success: #18794e;\n  --success-soft: #e7f6ee;\n  --warning: #b54708;\n  --warning-soft: #fdf1e4;\n  --danger: #c0362c;\n  --danger-soft: #fbe9e7;\n\n  --shadow: 0 2px 10px rgba(23, 50, 78, 0.06);\n  --shadow-lg: 0 10px 28px rgba(23, 50, 78, 0.12);\n}\n\n/* =========================\n   Fancy Loading Spinner\n========================= */\n\n.a3-repo-loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 20px;\n}\n\n.a3-repo-spinner {\n  width: 60px;\n  height: 60px;\n  border: 4px solid #e2e8f0;\n  border-top: 4px solid var(--primary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.a3-repo-loading-text {\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--muted);\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n.a3-repo-loading-dots::after {\n  content: '';\n  animation: dots 1.5s steps(4, end) infinite;\n}\n\n@keyframes dots {\n  0%, 20% { content: '.'; }\n  40% { content: '..'; }\n  60%, 100% { content: '...'; }\n}\n\n.a3-repo-error {\n  color: var(--danger);\n  margin-top: 20px;\n  font-weight: 500;\n}\n\n/* =========================\n   Repository Container\n========================= */\n\n.a3-repository-container {\n  padding: 24px 28px;\n  background: var(--background);\n  min-height: 100vh;\n  zoom: 0.8;\n}\n\n.a3-repository-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 4px;\n}\n\n.a3-repository-container h2 {\n  margin: 0 0 6px;\n  color: var(--heading);\n  font-size: 24px;\n  font-weight: 800;\n}\n\n.a3-repository-subtitle {\n  margin: 0 0 24px;\n  color: var(--muted);\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.new-a3-btn {\n  background: #0369a1;\n  color: #fff;\n  padding: 10px 18px;\n  border-radius: 999px;\n  border: none;\n  font-weight: 700;\n  box-shadow: 0 8px 22px rgba(3,105,161,0.18);\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.15s ease;\n}\n\n.new-a3-btn:hover {\n  background: #025a8a;\n  transform: translateY(-2px);\n  box-shadow: 0 12px 30px rgba(3,105,161,0.26);\n}\n\n.new-a3-btn:active {\n  background: #024f7a;\n  transform: translateY(0);\n}\n\n/* =========================\n   KPI Section\n========================= */\n\n.a3-kpi-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 14px;\n  margin-bottom: 24px;\n}\n\n.a3-kpi-card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: var(--shadow);\n}\n\n.a3-kpi-value {\n  font-size: 24px;\n  font-weight: 800;\n  color: var(--primary);\n}\n\n.a3-kpi-label {\n  margin-top: 4px;\n  font-size: 11px;\n  text-transform: uppercase;\n  color: var(--muted);\n  font-weight: 700;\n}\n\n/* =========================\n   Repository Cards Grid\n========================= */\n\n.a3-content-layout {\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n}\n\n.a3-left-column {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 280px;\n  min-width: 260px;\n  position: sticky;\n  top: 16px;\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE and Edge */\n  padding-bottom: 20px;\n}\n\n.a3-left-column::-webkit-scrollbar {\n  display: none; /* Chrome, Safari, Opera */\n}\n\n.a3-repository-grid {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));\n  gap: 16px;\n}\n\n/* =========================\n   Repository Card\n========================= */\n\n.a3-summary-card {\n  background: var(--surface);\n  border: 1.5px solid var(--border);\n  border-radius: 14px;\n  padding: 18px;\n  box-shadow: var(--shadow);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  transition: all 0.15s ease;\n}\n\n.a3-summary-card:hover {\n  border-color: var(--primary-light);\n  box-shadow: var(--shadow-lg);\n  transform: translateY(-2px);\n}\n\n.a3-card-title {\n  margin: 0 0 12px;\n  font-size: 15px;\n  font-weight: 800;\n  line-height: 1.4;\n  color: var(--heading);\n}\n\n.a3-card-detail-item {\n  margin-bottom: 8px;\n  font-size: 12.5px;\n  color: var(--muted);\n}\n\n.a3-card-detail-item strong {\n  color: var(--heading);\n}\n\n.a3-card-detail-item:last-of-type {\n  margin-bottom: 16px;\n}\n\n/* =========================\n   Metadata Inline Row\n========================= */\n\n.a3-card-meta-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 10px;\n  font-size: 12.5px;\n  color: var(--muted);\n  font-weight: 500;\n}\n\n.a3-card-meta-row span {\n  color: var(--heading);\n  font-weight: 600;\n}\n\n.dot-separator {\n  color: var(--muted) !important;\n  font-weight: 400 !important;\n  margin: 0 2px;\n}\n\n/* =========================\n   Tag Highlighting Options\n========================= */\n\n\n/* Option 3: Teal/Cyan Modern */\n.a3-card-tag {\n  display: inline-block;\n  background: #ecfeff;\n  color: #0e7490;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 5px 12px;\n  border-radius: 8px;\n  border-left: 3px solid #06b6d4;\n  box-shadow: 0 1px 2px rgba(6, 182, 212, 0.1);\n}\n\n\n\n/* =========================\n   Status Badges\n========================= */\n\n.a3-card-status-badge {\n  font-size: 10px;\n  font-weight: 800;\n  padding: 3px 10px;\n  border-radius: 999px;\n}\n\n.a3-card-status-implemented {\n  background: var(--success-soft);\n  color: var(--success);\n}\n\n.a3-card-status-inprogress {\n  background: var(--warning-soft);\n  color: var(--warning);\n}\n\n.a3-card-status-notstarted {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.a3-card-status-default {\n  background: #eef2f6;\n  color: #475569;\n}\n\n/* =========================\n   Savings\n========================= */\n\n.a3-card-savings-value {\n  color: var(--success);\n  font-weight: 800;\n}\n\n.a3-card-savings-not-recorded {\n  color: #9ca3af;\n  font-weight: 500;\n  font-style: italic;\n}\n\n/* =========================\n   Open Button\n========================= */\n\n.a3-card-open-btn {\n  background: var(--primary);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 16px;\n  font-size: 12px;\n  font-weight: 800;\n  cursor: pointer;\n  margin-top: 12px;\n  transition: all 0.2s ease;\n}\n\n.a3-card-open-btn:hover {\n  background: var(--primary-dark);\n}\n\n/* =========================\n   Card Action Buttons Row\n========================= */\n\n.a3-card-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 14px;\n  flex-wrap: wrap;\n}\n\n.a3-card-action-btn {\n  flex: 1;\n  min-width: 60px;\n  border: none;\n  border-radius: 7px;\n  padding: 8px 10px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.a3-card-btn-open {\n  background: var(--primary);\n  color: #fff;\n}\n\n.a3-card-btn-open:hover {\n  background: var(--primary-dark);\n}\n\n.a3-card-btn-edit {\n  background: #f3f4f6;\n  color: #4b5563;\n  border: 1.5px solid #d1d5db;\n}\n\n.a3-card-btn-edit:hover {\n  background: #e5e7eb;\n}\n\n.a3-card-btn-export {\n  background: #f3f4f6;\n  color: #4b5563;\n  border: 1.5px solid #d1d5db;\n}\n\n.a3-card-btn-export:hover {\n  background: #e5e7eb;\n}\n\n.a3-card-btn-delete {\n  background: #f3f4f6;\n  color: #4b5563;\n  border: 1.5px solid #d1d5db;\n}\n\n.a3-card-btn-delete:hover {\n  background: #e5e7eb;\n}\n\n.a3-card-btn-confirm-delete {\n  background: var(--danger);\n  color: #fff;\n  border: 1.5px solid var(--danger);\n  animation: a3-pulse 0.25s ease;\n}\n\n.a3-card-btn-confirm-delete:hover {\n  background: #a02820;\n}\n\n@keyframes a3-pulse {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.06); }\n  100% { transform: scale(1); }\n}\n\n/* =========================\n   Loading & Empty States\n========================= */\n\n.a3-loading {\n  text-align: center;\n  padding: 40px 20px;\n  color: #9aa7b8;\n  font-size: 14px;\n}\n\n.a3-empty-state {\n  grid-column: 1 / -1; /* Span all columns */\n  text-align: center;\n  padding: 60px 40px;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-radius: 16px;\n  border: 2px dashed #cbd5e1;\n  margin: 40px auto;\n  max-width: 500px;\n}\n\n.a3-empty-state-icon {\n  font-size: 64px;\n  margin-bottom: 20px;\n  opacity: 0.6;\n  animation: float 3s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.a3-empty-state-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #475569;\n  margin-bottom: 12px;\n}\n\n.a3-empty-state-message {\n  font-size: 15px;\n  color: #64748b;\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\n.a3-empty-state-suggestion {\n  font-size: 13px;\n  color: #94a3b8;\n  font-style: italic;\n}\n\n.a3-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.a3-card-title {\n  margin: 0;\n  flex: 1;\n  font-size: 15px;\n  font-weight: 800;\n  color: var(--heading);\n}\n\n/* =========================\n   Filters Panel\n========================= */\n\n.a3-filters-panel {\n  width: 100%;\n  background: var(--surface);\n  border: 1.5px solid var(--border);\n  border-radius: 14px;\n  padding: 14px 14px;\n  box-shadow: var(--shadow);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  box-sizing: border-box;\n}\n\n.a3-filters-panel::-webkit-scrollbar {\n  display: none; /* Chrome, Safari, Opera */\n}\n\n.a3-filters-title {\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--heading);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-bottom: 2px;\n}\n\n.a3-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.a3-filter-label {\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--heading);\n}\n\n.a3-filter-input,\n.a3-filter-select {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1.5px solid var(--border);\n  border-radius: 8px;\n  font-size: 12.5px;\n  color: var(--text);\n  background: var(--surface-soft);\n  outline: none;\n  transition: border-color 0.15s;\n  box-sizing: border-box;\n}\n\n.a3-filter-input:focus,\n.a3-filter-select:focus {\n  border-color: var(--primary-light);\n  background: #fff;\n}\n\n.a3-filter-reset-btn {\n  margin-top: 4px;\n  width: 100%;\n  padding: 8px 12px;\n  background: #e2e8f0;\n  color: #475569;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s, opacity 0.15s;\n}\n\n.a3-filter-reset-btn:hover:not(:disabled) {\n  background: #cbd5e1;\n  color: #334155;\n}\n\n.a3-filter-reset-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* =========================\n   Insights Box\n========================= */\n\n.a3-insights-box {\n  background: #e0f2fe;\n  border: 1.5px solid #bae6fd;\n  border-radius: 14px;\n  padding: 12px 14px;\n  box-sizing: border-box;\n}\n\n.a3-insights-box::-webkit-scrollbar {\n  display: none; /* Chrome, Safari, Opera */\n}\n\n.a3-insights-title {\n  font-size: 12px;\n  font-weight: 800;\n  color: #0369a1;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-bottom: 8px;\n}\n\n.a3-insights-list {\n  margin: 0;\n  padding-left: 18px;\n  list-style: disc;\n}\n\n.a3-insights-list li {\n  font-size: 12px;\n  color: #0c4a6e;\n  line-height: 1.5;\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n\n.a3-insights-list li:last-child {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
